export const normalizeColumnValue = value => {
  if (value === null || value === undefined) {
    return ""
  }

  return String(value)
}

export const isSameColumn = (leftValue, rightValue) => {
  const normalizedLeftValue = normalizeColumnValue(leftValue)
  const normalizedRightValue = normalizeColumnValue(rightValue)

  return (
    normalizedLeftValue !== "" &&
    normalizedRightValue !== "" &&
    normalizedLeftValue === normalizedRightValue
  )
}
